/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Exhibition } from '../../models/exhibition';
import { NewExhibition } from '../../models/new-exhibition';

export interface EditorCreateExhibition$Params {
      body?: NewExhibition
}

export function editorCreateExhibition(http: HttpClient, rootUrl: string, params?: EditorCreateExhibition$Params, context?: HttpContext): Observable<StrictHttpResponse<Exhibition>> {
  const rb = new RequestBuilder(rootUrl, editorCreateExhibition.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Exhibition>;
    })
  );
}

editorCreateExhibition.PATH = '/editor/exhibitions';
